<template>
  <div class="extension-container">
    <!-- 悬浮头部 -->
    <div class="sticky-header">
      <header class="header">
        <p class="header-title">My Extension</p>
        <button class="header-button" @click="goRepaymentPage">
          Full Payment
        </button>
      </header>

      <!-- 悬浮状态卡片 -->
      <div
        class="card status-card"
        style="margin-top: 20px"
        v-if="extensionInfo.extensionBoolean"
      >
        <div class="status-indicator">
          <span class="days-count">{{ extensionInfo.period }}</span>
          <span class="days-label">Extension days</span>
        </div>

        <div class="status-details">
          <div class="detail-item">
            <span class="detail-value"
              >${{ extensionInfo.extensionAccrStr }}</span
            >
            <span class="detail-label">Extension cost</span>
          </div>
          <div class="detail-item">
            <span class="detail-value">{{
              formatDate(extensionInfo.extensionDueDateStr)
            }}</span>
            <span class="detail-label">New due date</span>
          </div>
        </div>
      </div>
    </div>

    <main class="content">
      <!-- 内容区域 -->
      <!-- 延期详情卡片 -->
      <div class="card info-card" v-if="extensionInfo.extensionBoolean">
        <div class="info-row">
          <span>Account holder:</span>
          <span>{{ extensionInfo.titular }}</span>
        </div>

        <!-- Extension Payment Button -->
        <div style="margin-top: 20px; text-align: center;">
          <button
            class="primary-btn"
            @click="copyCLABE"
            style="width: 100%; max-width: 320px;"
          >
            Extension Payment →
          </button>
        </div>
      </div>

      <!-- 无法延期提示 -->
      <div
        class="card info-card"
        style="margin-top: 20px"
        v-if="!extensionInfo.extensionBoolean"
      >
        <p class="no-extension-text">
          You cannot request an extension temporarily
        </p>
      </div>

      <!-- Safe Repayment Reminder -->
      <div
        class="card warning-card"
        v-if="extensionInfo.extensionBoolean"
      >
        <div style="display: flex; align-items: flex-start;">
          <span class="warning-icon">⚠️</span>
          <div>
            <p class="warning-title">
              Safe Repayment Reminder
            </p>
            <p class="warning-desc">
              Always repay using the UPIID shown in this App.
            </p>
            <p class="warning-desc" style="margin-bottom: 0;">
              Do NOT trust any UPIID shared in WhatsApp or personal messages.
            </p>
          </div>
        </div>
      </div>

      <!-- UTR Input Section -->
      <div
        class="card utr-card"
        v-if="extensionInfo.extensionBoolean"
      >
        <div class="utr-input-container">
          <label class="utr-label">Enter UTR Number</label>
          <p class="utr-desc">
            After completing payment, please enter your 12-digit UTR(UPI Ref.
            No.) below ↓
          </p>
          <div class="input-wrapper">
            <input
              v-model="utr"
              class="utr-input"
              type="text"
              placeholder="Enter 12-digit UTR number"
              maxlength="12"
            />
            <button class="paste-btn" @click="pasteUTR">Paste</button>
          </div>
          <div class="error-message" v-if="utr && !isValidUTR()">
            Please enter a valid 12-digit UTR number
          </div>

          <!-- Success message - only shown after successful submission -->
          <div class="success-message" v-if="utrSubmitted && utrSuccessMessage">
            {{ utrSuccessMessage }}
          </div>

          <button
            class="submit-utr-btn"
            @click="submitUTR"
            :disabled="!isValidUTR()"
          >
            Submit UTR →
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import CallApp from "callapp-lib";

export default {
  name: "ExtensionPage",
  data() {
    return {
      extensionInfo: {},
      bankMethods: {},
      repaymentCode: null,
      key: "",
      currentDate: "",
      expandedCategories: {},
      lastExpandedCategory: null,
      utr: "",
      utrSubmitted: false,
      utrSuccessMessage: "",
    };
  },
  mounted() {
    document.title = "My Extension";
  },
  created() {
    this.setCurrentDate();
    this.getDetailInfo();
  },
  methods: {
    formatDate(dateStr) {
      return dateStr ? dateStr.substr(0, 10) : "";
    },
    setCurrentDate() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      const d = String(now.getDate()).padStart(2, "0");
      this.currentDate = `${y}-${m}-${d}`;
    },
    async getDetailInfo() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      let res = await this.$Http.getExtensionInfo(
        {
          key: keyStr,
        },
        true,
      );
      this.extensionInfo = res;

      try {
        let bankRes = await this.$Http.repaymentMethod({ key: keyStr });
        this.bankMethods = {
          "Payment Methods": Object.keys(bankRes).map((key) => ({
            repayCode: key,
            repayMethodName: key,
            selected: bankRes[key],
          })),
        };
        Object.keys(bankRes).map((key) => {
          if (bankRes[key]) {
            this.repaymentCode = key;
          }
        });
        this.initExpandedState();
      } catch (error) {
        console.error("Error fetching bank methods:", error);
      }
    },
    initExpandedState() {
      const categories = Object.keys(this.bankMethods);
      let selectedCategory = null;

      selectedCategory = categories[0];

      categories.forEach((category) => {
        const methods = this.bankMethods[category];
        const hasSelected = methods.some((method) => method.selected);
        if (hasSelected) {
          selectedCategory = category;
        }
      });

      categories.forEach((category) => {
        this.$set(this.expandedCategories, category, false);
      });

      if (selectedCategory) {
        this.$set(this.expandedCategories, selectedCategory, true);
        this.lastExpandedCategory = selectedCategory;
      } else if (categories.length > 0) {
        this.$set(this.expandedCategories, categories[0], true);
        this.lastExpandedCategory = categories[0];
      }
    },
    toggleCategory(category) {
      if (this.expandedCategories[category]) {
        this.$set(this.expandedCategories, category, false);
        this.lastExpandedCategory = null;
      } else {
        if (this.lastExpandedCategory) {
          this.$set(this.expandedCategories, this.lastExpandedCategory, false);
        }
        this.$set(this.expandedCategories, category, true);
        this.lastExpandedCategory = category;
      }
    },
    selectMethod(method) {
      Object.keys(this.bankMethods).forEach((category) => {
        this.bankMethods[category].forEach((m) => {
          this.$set(m, "selected", false);
        });
      });

      this.$set(method, "selected", true);
      this.repaymentCode = method.repayCode;
      const bankName = method.repayMethodName.includes("-")
        ? method.repayMethodName.split("-")[0]
        : method.repayMethodName;
      this.extensionInfo.repaymentBankName = bankName;
    },
    goRepaymentPage() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      this.$router.push({ path: "/repayment", query: { key: keyStr } });
    },
    getParamQueryString(url, name) {
      let subStr = name + "=";
      if (url.indexOf(subStr) !== -1) {
        let arr = url.split(subStr);
        let sub1 = arr[1];
        if (sub1.indexOf("&") !== -1) {
          let arr2 = sub1.split("&");
          return arr2[0];
        }
        return sub1;
      }
      return "";
    },
    async copyCLABE() {
      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let responseInfo = await this.$Http.repaymentUrl(
          {
            key: keyStr,
            repayCode: this.repaymentCode,
            extension: true,
          },
          false,
        );

        if (responseInfo && responseInfo.length > 0) {
          window.open(responseInfo, "_blank");
        }

        await this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "click_pay_button",
          },
          true,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    },
    isValidUTR() {
      return /^\d{12}$/.test(this.utr);
    },
    async pasteUTR() {
      try {
        const text = await navigator.clipboard.readText();
        if (/^\d{12}$/.test(text)) {
          this.utr = text;
        } else {
          this.utr = text;
        }
      } catch (err) {
        console.error("Failed to read clipboard contents: ", err);
      }
    },
    async submitUTR() {
      if (!this.isValidUTR()) {
        return;
      }

      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let response = await this.$Http.submitUrl(
          {
            key: keyStr,
            utr: this.utr,
            isExtend: true,
          },
          true,
        );

        console.log("UTR submitted successfully", response);

        if (this.$toast) {
          this.$toast.success("Success");
        } else {
          alert("Success");
        }

        this.utrSubmitted = true;
        this.utrSuccessMessage =
          response.message || "UTR submitted successfully!";
      } catch (error) {
        console.error("Error submitting UTR:", error);
        this.utrSubmitted = false;
        this.utrSuccessMessage = "";

        if (this.$toast) {
          this.$toast.fail("Failed to submit UTR");
        }
      }
    },
  },
};
</script>

<style scoped>
/* 基础容器：透明（继承全局冰蓝天光背景） */
.extension-container {
  min-height: 100vh;
  background-color: transparent;
  color: #16213F;
  padding-bottom: 40px;
}

/* 悬浮头部区域 */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: transparent;
}

/* 头部样式：通透白玻璃 Header */
.header {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94) 0%, rgba(244, 249, 255, 0.82) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  color: #16213F;
  padding: 18px 20px 48px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 24px 24px;
  border-bottom: 1px solid rgba(43, 91, 255, 0.16);
  box-shadow: 0 8px 24px rgba(43, 91, 255, 0.06);
}

.header-title {
  font-size: 20px;
  font-weight: 800;
  flex: 1;
  text-align: left;
  letter-spacing: 0.2px;
  margin: 0;
  color: #16213F;
}

.header-title::before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 10px;
  vertical-align: 2px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7A9BFF 0%, #2B5BFF 100%);
  box-shadow: 0 0 0 4px rgba(43, 91, 255, 0.12), 0 3px 8px rgba(43, 91, 255, 0.25);
}

.header-button {
  background: rgba(43, 91, 255, 0.08);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1.5px solid #7A9BFF;
  color: #2B5BFF;
  font-size: 13px;
  font-weight: 700;
  padding: 7px 16px;
  border-radius: 20px;
  cursor: pointer;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 10px rgba(43, 91, 255, 0.1);
  transition: all 0.2s ease;
}

.header-button:active {
  transform: scale(0.95);
  background: rgba(43, 91, 255, 0.18);
  box-shadow: 0 4px 14px rgba(43, 91, 255, 0.2);
}

/* 卡片通用样式：白玻璃拟态 + 大圆角 + 柔和投影 */
.card {
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-radius: 26px;
  padding: 22px;
  max-width: 600px;
  box-shadow: 0 18px 44px rgba(31, 62, 140, 0.09), 0 2px 10px rgba(31, 62, 140, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.92);
  margin: 0 16px 16px;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

/* 状态卡片：墨蓝 Hero 卡，呼应参考稿的深色信息卡 */
.status-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  background: linear-gradient(145deg, #121A40 0%, #182252 58%, #24327A 100%);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  color: #FFFFFF;
  margin-top: -36px;
  position: relative;
  z-index: 10;
  overflow: hidden;
  border: 1px solid rgba(122, 160, 255, 0.32);
  box-shadow: 0 18px 40px rgba(17, 24, 59, 0.28), 0 2px 10px rgba(17, 24, 59, 0.12);
}

/* Hero 卡：蓝色玻璃光斑 + 右下角金币暖光 */
.status-card::before {
  content: '';
  position: absolute;
  right: -34px;
  bottom: -52px;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 30%, rgba(255, 224, 130, 0.72) 0%, rgba(255, 201, 60, 0.3) 45%, transparent 74%);
  pointer-events: none;
}

.status-card::after {
  content: '';
  position: absolute;
  top: -70%;
  right: -18%;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(122, 160, 255, 0.42) 0%, rgba(122, 160, 255, 0.1) 48%, transparent 72%);
  pointer-events: none;
}

.status-indicator,
.status-details {
  position: relative;
  z-index: 1;
}

.status-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px 0 4px;
  border-right: 1px solid rgba(255, 255, 255, 0.18);
  min-width: 105px;
}

.days-count {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  color: #FFD45E;
  letter-spacing: -0.5px;
}

.days-label {
  font-size: 12px;
  margin-top: 6px;
  color: rgba(255, 255, 255, 0.72);
  font-weight: 600;
}

.status-details {
  flex: 1;
  display: flex;
  justify-content: space-around;
}

.detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-value {
  font-size: 18px;
  font-weight: 800;
  color: #FFFFFF;
  margin-bottom: 4px;
}

.detail-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.72);
  font-weight: 500;
}

/* 内容区域 */
.content {
  margin: 0 auto;
  padding-bottom: 120px;
  max-width: 600px;
}

/* 信息卡片 */
.info-card {
  padding: 20px;
  margin: 16px 16px 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background-color: #F1F6FF;
  border-radius: 14px;
  margin-bottom: 10px;
  border: 1px solid rgba(43, 91, 255, 0.12);
  font-size: 14px;
  color: #6B7B9B;
  font-weight: 500;
}

.info-row span:last-child {
  font-weight: 700;
  color: #16213F;
}

.no-extension-text {
  text-align: center;
  padding: 24px 16px;
  color: #F0554E;
  font-weight: 600;
  font-size: 15px;
}

/* Warning Card */
.warning-card {
  padding: 18px 20px;
  margin: 16px 16px 16px;
  background: #EAF2FF !important;
  border: 1px solid rgba(43, 91, 255, 0.22) !important;
  border-radius: 16px !important;
  box-shadow: 0 6px 20px rgba(43, 91, 255, 0.06) !important;
}

.warning-icon {
  font-size: 18px;
  color: #2B5BFF;
  margin-right: 10px;
}

.warning-title {
  font-weight: 700;
  margin: 0 0 6px 0;
  color: #1D42C8;
  font-size: 15px;
}

.warning-desc {
  margin: 0 0 4px 0;
  font-size: 13px;
  color: #6B7B9B;
  line-height: 1.4;
}

/* UTR Input Styles */
.utr-card {
  padding: 20px;
  margin: 0 16px 20px;
}

.utr-label {
  display: block;
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #16213F;
}

.utr-desc {
  font-size: 13px;
  color: #6B7B9B;
  margin: 0 0 14px 0;
  line-height: 1.4;
}

.input-wrapper {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.utr-input {
  flex: 1;
  padding: 12px 16px;
  background-color: #FFFFFF;
  border: 1.5px solid rgba(43, 91, 255, 0.22);
  border-radius: 14px;
  font-size: 15px;
  outline: none;
  color: #16213F;
  font-weight: 600;
  transition: all 0.2s;
}

.utr-input:focus {
  border-color: #2B5BFF;
  background-color: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(43, 91, 255, 0.15);
}

.utr-input::placeholder {
  color: #A6B3C9;
  font-weight: normal;
}

.paste-btn {
  background-color: rgba(43, 91, 255, 0.1);
  border: 1px solid rgba(43, 91, 255, 0.25);
  border-radius: 12px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 700;
  color: #2B5BFF;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(43, 91, 255, 0.1);
}

.paste-btn:active {
  transform: scale(0.95);
  background-color: rgba(43, 91, 255, 0.2);
}

.error-message {
  color: #F0554E;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
}

.success-message {
  color: #2B5BFF;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
}

/* 主行动按钮：参考稿的电光亮蓝 CTA */
.primary-btn,
.submit-utr-btn {
  position: relative;
  width: 100%;
  background: linear-gradient(105deg, #4E7BFF 0%, #2B5BFF 52%, #2349E8 100%);
  color: #FFFFFF;
  border: none;
  border-radius: 16px;
  padding: 16px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 10px 26px rgba(43, 91, 255, 0.28), 0 2px 6px rgba(17, 24, 59, 0.05);
  letter-spacing: 0.2px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.primary-btn::before,
.submit-utr-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 40%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 100%);
  border-radius: 14px 14px 0 0;
  pointer-events: none;
}

.primary-btn:hover,
.submit-utr-btn:hover:not(:disabled) {
  box-shadow: 0 12px 30px rgba(43, 91, 255, 0.45);
  transform: translateY(-1px);
}

.primary-btn:active,
.submit-utr-btn:active:not(:disabled) {
  transform: scale(0.98);
  opacity: 0.94;
  box-shadow: 0 4px 14px rgba(43, 91, 255, 0.3);
}

.submit-utr-btn:disabled {
  background: #E8EEFA;
  color: #B4C0D6;
  box-shadow: none;
  cursor: not-allowed;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .status-card {
    flex-direction: row;
  }
}
</style>
